import { Paper, SimpleGrid, Stack, Text, Title } from '@mantine/core';
import { useI18n } from '@/shared/i18n';
import { QualityTile } from './MetricCard';

export interface ActivityPanelProps {
  newImports: number;
  unmatched: number;
  readyToConfirm: number;
  successfulPostings: number;
  failedPostings: number;
}

const activityLinks = {
  newImports: '/bank-statements/list',
  unmatched: '/accountant-workbench?state=attention&matchStatus=Unmatched',
  readyToConfirm: '/accountant-workbench?state=ready',
  successfulPostings: '/accountant-workbench?state=completed',
  failedPostings: '/accountant-workbench?state=attention',
} as const;

export function ActivityPanel({
  newImports,
  unmatched,
  readyToConfirm,
  successfulPostings,
  failedPostings,
}: ActivityPanelProps) {
  const { t } = useI18n();

  return (
    <Paper p="lg" radius="lg" withBorder shadow="xs" data-testid="dashboard-activity-panel">
      <Title order={3}>{t('dashboard.activity.title')}</Title>
      <Text size="sm" c="dimmed" mt={4}>{t('dashboard.activity.subtitle')}</Text>
      <SimpleGrid cols={{ base: 1, sm: 2 }} mt="md" spacing="sm">
        <QualityTile
          title={t('dashboard.cards.newImports.title')}
          value={newImports}
          tone="info"
          to={activityLinks.newImports}
          testId="dashboard-activity-new-imports"
        />
        <QualityTile
          title={t('dashboard.cards.unmatched.title')}
          value={unmatched}
          tone="warning"
          to={activityLinks.unmatched}
          testId="dashboard-activity-unmatched"
        />
        <QualityTile
          title={t('dashboard.cards.ready.title')}
          value={readyToConfirm}
          tone="success"
          to={activityLinks.readyToConfirm}
          testId="dashboard-activity-ready"
        />
        <QualityTile
          title={t('dashboard.cards.successfulPostings.title')}
          value={successfulPostings}
          tone="success"
          to={activityLinks.successfulPostings}
          testId="dashboard-activity-successful-postings"
        />
        <QualityTile
          title={t('dashboard.cards.failedPostings.title')}
          value={failedPostings}
          tone="danger"
          to={activityLinks.failedPostings}
          testId="dashboard-activity-failed-postings"
        />
      </SimpleGrid>
    </Paper>
  );
}

export function ActivityPanelSkeleton() {
  const { t } = useI18n();
  return (
    <Paper p="lg" radius="lg" withBorder shadow="xs">
      <Stack gap="xs">
        <Title order={3}>{t('dashboard.activity.title')}</Title>
        <Text c="dimmed" size="sm">{t('dashboard.activity.subtitle')}</Text>
      </Stack>
    </Paper>
  );
}
